export default class ConsoleSender {
  send(payload, acknowledge) {
    const handledLogKeys = [];
    payload.forEach(payloadElement => {
      console.log(payloadElement); // eslint-disable-line no-console
      handledLogKeys.push(payloadElement.uid);
    });
    acknowledge(handledLogKeys);
  }
}
//# sourceMappingURL=index.js.map